import React from 'react';
import DefinitionCard from '../../../Elements/DefinitionCard';

function CardsDemoComponent() {
  return (
    <div>
      <div className='dsg-row'>
        <div className='dsg-demo-label'>Definition cards (.def-cols &gt; .def-card &gt; .def-row)</div>
      </div>
      <div className='def-cols'>
        <div className='def-card'>
          <div className='def-row'>
            <div className='k'>Client</div>
            <div className='v'>Demo Client Kft.</div>
          </div>
          <div className='def-row'>
            <div className='k'>Office</div>
            <div className='v'>BARE Vienna</div>
          </div>
          <div className='def-row'>
            <div className='k'>Fieldwork fee</div>
            <div className='v money'>€ 1,250.00</div>
          </div>
          <div className='def-row'>
            <div className='k'>Notes</div>
            <div className='v muted'>Not provided</div>
          </div>
        </div>
        <div className='def-card'>
          <div className='def-row'>
            <div className='k'>Status</div>
            <div className='v'>Confirmed</div>
          </div>
          <div className='def-row'>
            <div className='k'>Evaluations</div>
            <div className='v'>42</div>
          </div>
          <div className='def-row def-row-stacked'>
            <div className='k'>Scope</div>
            <div className='v v-long'>
              Full-service mystery shopping across all retail locations in the DACH region.
            </div>
          </div>
        </div>
        <div className='def-card def-full'>
          <div className='def-row def-row-stacked'>
            <div className='k'>Summary</div>
            <div className='v v-long'>
              A .def-full card spans the whole 3-column grid; use it for long free-text fields that would otherwise be
              cramped in a single column.
            </div>
          </div>
        </div>
      </div>

      <div className='dsg-row'>
        <div className='dsg-demo-label'>The same cards from rows (DefinitionCard)</div>
      </div>
      <div className='def-cols'>
        <DefinitionCard
          rows={[
            { label: 'Runs', value: 'Automatically, every morning' },
            { label: 'First month', value: 'October 2026' },
            { label: 'Purchase order #', value: '' },
          ]}
        />
        <DefinitionCard
          isFullWidth={true}
          rows={[{ label: 'Invoice comments', value: '{Month} {Year} Mystery Shops', isLong: true }]}
        />
      </div>

      <div className='dsg-row'>
        <div className='dsg-demo-label'>Metric tiles (.metric-row &gt; .metric)</div>
      </div>
      <div className='def-cols'>
        <div className='metric-row'>
          <div className='metric'>
            <span className='k'>Active shops</span>
            <span className='v'>128</span>
          </div>
          <div className='metric'>
            <span className='k'>Completed</span>
            <span className='v'>96</span>
          </div>
          <div className='metric'>
            <span className='k'>Overdue</span>
            <span className='v'>4</span>
          </div>
        </div>
      </div>

      <div className='dsg-row'>
        <div className='dsg-demo-label'>Titled container card (.office-card)</div>
      </div>
      <div className='office-card'>
        <div className='office-head'>
          <span className='oh-ico'>
            <i className='fa-solid fa-user' />
          </span>
          <h3>1st User — Vienna</h3>
          <span className='hero-chip flag'>BARE Vienna</span>
        </div>
        <div className='office-body'>
          <div className='def-cols'>
            <div className='def-card'>
              <div className='def-row'>
                <div className='k'>UserId</div>
                <div className='v'>10427</div>
              </div>
              <div className='def-row'>
                <div className='k'>UserName</div>
                <div className='v'>jdoe</div>
              </div>
            </div>
          </div>
          <div className='role-chips'>
            <span className='role-chip alt'>Admin</span>
            <span className='role-chip alt'>Operations</span>
            <span className='role-chip alt'>Finance</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export const cardsDemo = {
  id: 'cards',
  title: 'Cards',
  category: 'Cards',
  importPath: 'src/Css/design-system/bravo-ds.css (.def-cols / .def-card / .metric / .office-card)',
  notes: [
    'CSS card primitives. Elements/TabList/TabListTableFigma.js renders detail views as def-cards; Elements/DefinitionCard renders one def-card from { label, value, isLong } rows (isFullWidth adds .def-full; an empty value shows a muted "Not set").',
    '.def-cols is a 3-column grid of .def-card; each .def-card holds .def-row key/value pairs (.k + .v). Add .def-full to make a card span all columns.',
    '.v modifiers: .money (navy, tabular numerals), .muted (greyed "not provided"); .def-row-stacked + .v-long stacks a long value under its label.',
    '.metric-row + .metric are stat tiles (label + big navy number). .office-card is a titled container: .office-head (.oh-ico + h3 + .hero-chip.flag) over .office-body.',
    'Role indicators use .role-chips > .role-chip (.alt for the sky-blue variant). All classes only apply inside a .bravo-ds subtree.',
  ],
  snippet:
    "<div className='def-cols'>\n  <div className='def-card'>\n    <div className='def-row'>\n      <div className='k'>Client</div>\n      <div className='v'>Demo Client Kft.</div>\n    </div>\n  </div>\n</div>",
  render: CardsDemoComponent,
};
